/**
 * Scroll Reveal — lightweight IntersectionObserver-based reveal animations.
 *
 * Usage in Liquid:
 *   <div data-reveal="fade-up">...</div>
 *   <div data-reveal="fade-up" data-reveal-delay="0.2">...</div>
 *   <div data-reveal="fade-left" data-reveal-once>...</div>
 *
 * Supported reveal types: fade-up, fade-in, fade-left, fade-right
 * CSS classes and keyframes are in bloomin8-custom.css
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.classList.add('is-revealed');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          if (entry.target.hasAttribute('data-reveal-once')) {
            observer.unobserve(entry.target);
          }
        } else if (!entry.target.hasAttribute('data-reveal-once')) {
          entry.target.classList.remove('is-revealed');
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  function observe() {
    document.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach(function (el) {
      observer.observe(el);
    });
  }

  // Initial observation
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  // Re-observe after Shopify section rendering (theme editor + AJAX navigation)
  document.addEventListener('shopify:section:load', observe);
  document.addEventListener('shopify:section:reorder', observe);
})();
